import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
@Component({
  selector: 'sm-phone-check-for-member-from-left-panel',
  templateUrl: './phone-check-for-member-from-left-panel.component.html',
  styleUrls: ['./phone-check-for-member-from-left-panel.component.scss']
})
export class PhoneCheckForMemberFromLeftPanelComponent   implements OnInit, OnDestroy
{
  toShowAccounts: boolean = false;
  apisub: Subscription;
  selectedAcc: any = [];
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
          )!,
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  loader: boolean = false;
  accounts: any = [];
  public newMemberData: any = {};
  constructor(
    private apiservice: ApiService,
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private loaderservice: LoaderServiceService,
    private activemodal: MatDialogRef<PhoneCheckForMemberFromLeftPanelComponent>,
    private dialog: MatDialog,
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER
      ) {
        this.accounts = [];
        if (resdata.result) {
          this.accounts = resdata.result;
          this.accounts.forEach((element: any) => {
            element.selected = false;
          });
          this.toShowAccounts = true;
          this.loaderservice.showLoader = false;
        } else {
          this.activemodal.close();
          let data = {
            entityHash: this.parentdata.entityHash,
            eph: this.parentdata.eph,
            // serviceType: this.interestType,
          };
          let dialogref = this.dialog.open(AddMemberComponent, {
            width: "650px",
            data: {
              title: "Add member",
              ref: this.dialog,
              data: data,
              memberData: {
                countryCode: this.selectedCountryCode.dial_code,
                code: this.selectedCountryCode.code,
                phone: this.newMemberData.customerPh,
              },
            },
          });
          this.loaderservice.showLoader = false;
        }
      }
    });
  }

  ngOnInit(): void {
    if(this.parentdata?.data){
      this.accounts = this.parentdata?.data;
      this.newMemberData.customerPh = this.parentdata?.phone
      this.toShowAccounts = true;

    }
  }

  selectAccount(account: any) {
    this.selectedAcc = [];
    this.accounts.forEach((element: any) => {
      element.selected = false;
    });
    account.selected = true;

    this.selectedAcc.push(account);
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code,
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  onSelectNext() {
    this.activemodal.close(this.selectedAcc)
    
  }

  back() {
    this.toShowAccounts = false;
  }
  formChecker() {
    if (this.newMemberData.customerPh) {
      if (
        this.newMemberData.customerPh.length >= 3 &&
        this.newMemberData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  onPost() {
    if (
      this.newMemberData.customerPh &&
      this.newMemberData.customerPh.length >= 3
    ) {
      this.loaderservice.showLoader = true;
      this.apiservice.getAccountDataByPhoneNumber(
        this.parentdata.entityHash,
        this.selectedCountryCode.dial_code,
        this.newMemberData.customerPh,
      );
    }
  }
  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
